import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/sec/code/list'
    return request.post(url,data)
}

export function all() {
    let url = '/sec/code/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/sec/code/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/sec/code/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/sec/code/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/sec/code/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/sec/code/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/sec/code/dmz/options'
    return request.get(url)
}

export function upload(file) {
    let url = '/sec/code/upload';
    let forms = new FormData()
    forms.append("file",file)
    let config = {
        headers:{'Content-Type':'multipart/form-data'}
    }; //
    return request.post(url,forms,config)
}